import { render, staticRenderFns } from "./Tenthousand.vue?vue&type=template&id=567bf9d0&"
import script from "./Tenthousand.vue?vue&type=script&lang=ts&"
export * from "./Tenthousand.vue?vue&type=script&lang=ts&"
import style0 from "./Tenthousand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports